// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar-module__navbar___2YBen","logo":"Navbar-module__logo___1OT6I"};